import { modal } from '../templates/modal';
import { Template } from '../templates/Template';

export class Modal {
    public static open(
        title: string,
        content?: HTMLElement[] | HTMLElement | string,
        icons?: HTMLElement[] | HTMLElement | string,
    ): void {
        const contentTemplate = Modal._clone(content);
        const iconsTemplate = Modal._clone(icons);

        const template = modal(title, contentTemplate, iconsTemplate);

        let modalContainer = document.querySelector<HTMLElement>('#modal-container');

        if (modalContainer === null) {
            modalContainer = Template.createElement('div', { id: 'modal-container' });
            document.body.prepend(modalContainer);
        }

        modalContainer.classList.add('active');

        modalContainer.innerHTML = '';
        modalContainer.appendChild(template);

        Modal._addEventListeners();
    }

    public static close(): void {
        const modalContainer = document.querySelector<HTMLElement>('#modal-container');

        if (modalContainer === null) {
            return;
        }

        modalContainer.classList.remove('active');
    }

    private static _addEventListeners(): void {
        const closeBtn = document.querySelector<HTMLElement>('.jomiba-modal__close');

        if (closeBtn === null) {
            return;
        }

        closeBtn.addEventListener('click', Modal.close);
    }

    private static _clone(
        element?: HTMLElement[] | HTMLElement | string,
    ): HTMLElement[] | HTMLElement | string | undefined {
        let cloned = element;

        if (Array.isArray(element)) {
            cloned = element.map((el) => el.cloneNode(true)) as HTMLElement[];
        } else if (element instanceof HTMLElement) {
            cloned = element.cloneNode(true) as HTMLElement;
        }

        return cloned;
    }
}
